import WoodlogCountingTypes from "./woodlog-counting.types";

const INITIAL_STATE = {
	// general
	error: null,
	loading: false,
	plural: [],
};

const woodlogCountingReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case WoodlogCountingTypes.CLEAR_ERROR:
			return {
				...state,
				error: null,
			};
		case WoodlogCountingTypes.FETCH_WOODLOG_COUNTING_START:
			return {
				...state,
				loading: true,
			};
		case WoodlogCountingTypes.FETCH_WOODLOG_COUNTING_FAILURE:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		case WoodlogCountingTypes.FETCH_WOODLOG_COUNTING_SUCCESS: {
			return {
				...state,
				plural: action.payload,
				loading: false,
			};
		}
		default:
			return state;
	}
};

export default woodlogCountingReducer;